import {Checkbox} from "@mui/material";
import {IExportMutateContext} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {useMemo} from "react";
import {ColumnId} from "@ui/tableCustom/types/columns";

const buttonToggleColumnExportSx = {
    padding: 0,
}

interface IProps<T> {
    exportMutate: IExportMutateContext<T>,
    id: ColumnId<T>,
}

function ButtonToggleColumnExportBase<T>({
                                             exportMutate,
                                             id,
                                         }: IProps<T>) {
    const {
        onChangeColumn,
        hasExportColumn,
    } = exportMutate;

    const handleChange = () => {
        if (onChangeColumn) {
            onChangeColumn(id)
        }
    }

    const checked = useMemo(() => {
        return hasExportColumn(id)
    }, [hasExportColumn])

    return (
        <Checkbox
            sx={buttonToggleColumnExportSx}
            onChange={handleChange}
            checked={checked}
        />
    )
};
export default ButtonToggleColumnExportBase;
